export const TARIFF_TYPE_DAILY = 'daily';
export const TARIFF_TYPE_HOURLY = 'hourly';
export const TARIFF_TYPE_WEEKLY = 'weekly';
export const TARIFF_TYPE_TOTAL = 'total';
